import axios from 'axios';

const AERODATA_URL = 'https://aerodata.nexatlas.com';

const axiosInstance = axios.create({ baseURL: AERODATA_URL });

export default axiosInstance;
